<div class="row section-header justify-content-between">
  <span>POS Device</span>
</div>
<app-pos-terminal
  #posTerminal
  [data]="data"
  [showAddDevice]="env.isShowAddPosDevice"
  [device]="device.POS"
  [version]="version"
  [maxDevices]="maxDevicesPOS"
></app-pos-terminal>
<ng-container *ngIf="env.isShowHandDevice">
  <hr class="section-divider" />

  <div class="row section-header justify-content-between">
    <span>HAND Device</span>
  </div>
  <app-pos-terminal
    #handTerminal
    [data]="data"
    [device]="device.HAND"
    [version]="version"
    [maxDevices]="maxDevicesHand"
  ></app-pos-terminal>
</ng-container>
<ng-container *ngIf="env.isShowBuddyDevice">
  <hr class="section-divider" />

  <div class="row section-header justify-content-between">
    <span>Buddy Device</span>
  </div>
  <app-pos-terminal
    #buddyTerminal
    [data]="data"
    [device]="device.BUDDY"
    [version]="version"
    [maxDevices]="maxDevicesBuddy"
  ></app-pos-terminal>
</ng-container>
